
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersSun as ObiLightRainShowersSunElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-sun.js';
 
 
 

 
 export const ObiLightRainShowersSun = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-sun',
   elementClass: ObiLightRainShowersSunElement,
   events: {
     
   }
  });
 
 